import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface CandidatAnimal {
  animalId: number; numero?: string; nom?: string; espece?: string; genre?: string; race?: string;
  troupeauId?: number; photoId?: number;
  /** HAUTE | MOYENNE | FAIBLE */
  confiance?: string; ressemblances?: string; differences?: string;
}

export interface ResultatReconnaissance {
  id: number; niveau?: string; photoExploitable: boolean; conseilPhoto?: string; description?: string;
  candidats: CandidatAnimal[]; compares: number; proposerApprofondi: boolean; retour?: string;
  animalConfirmeId?: number; restants?: number;
}

export interface StatutReconnaissance { avecPhoto: number; sansPhoto: number; restants: number; maxCandidats: number; }

/** Reconnaître un animal de la ferme sur une photo (comparée aux photos de référence des fiches) */
@Injectable({ providedIn: 'root' })
export class ReconnaissanceAnimalService {

  private readonly base = `${environment.BASE_URL}/api/betail/identification-photo`;

  constructor(private http: HttpClient) {}

  statut(troupeauId?: number): Observable<StatutReconnaissance> {
    return this.http.get<StatutReconnaissance>(`${this.base}/statut`, { params: troupeauId ? { troupeauId } : {} });
  }

  identifier(photo: File, troupeauId?: number): Observable<ResultatReconnaissance> {
    const fd = new FormData();
    fd.append('photo', photo);
    fd.append('langue', 'fr');
    if (troupeauId) { fd.append('troupeauId', String(troupeauId)); }
    return this.http.post<ResultatReconnaissance>(this.base, fd);
  }

  approfondir(id: number): Observable<ResultatReconnaissance> {
    return this.http.post<ResultatReconnaissance>(`${this.base}/${id}/approfondir`, {});
  }

  /** animalId null = aucun des animaux proposés ; ajouterPhoto relie la photo à la fiche (reconnaissances suivantes plus sûres) */
  retour(id: number, animalId: number | null, ajouterPhoto = true): Observable<ResultatReconnaissance> {
    return this.http.patch<ResultatReconnaissance>(`${this.base}/${id}/retour`, { animalId, ajouterPhoto });
  }
}
